module.exports = __webpack_public_path__ + "images/directory/featured-hero/googleDrive.b8300fefa3a59acfd7a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/googleDrive.jpg
// module id = Y3wn
// module chunks = 0